import { useTranslation } from 'react-i18next';

/**
 * Visible-when-focused skip link. First focusable element on every page so
 * keyboard / SR users can jump straight to the main landmark instead of
 * tabbing through the whole nav. Mounted at the App root.
 */
export function SkipToMain() {
  const { t } = useTranslation();
  return (
    <a
      href="#main"
      // Anchors with href are focusable by default — explicit tabIndex={0}
      // is belt-and-suspenders for older Safari versions where the
      // sr-only/focus-visible interaction can occasionally drop focusability.
      tabIndex={0}
      className="sr-only fixed left-2 top-2 z-50 rounded-2xl bg-jade-500 px-4 py-2 text-sm font-medium text-white shadow-card focus:not-sr-only focus:outline-none focus:ring-2 focus:ring-jade-500 focus:ring-offset-2 focus:ring-offset-cream-50 dark:focus:ring-offset-midnight-950"
    >
      {t('a11y.skipToMain', 'Skip to main content')}
    </a>
  );
}
